export const actionListDefaultTranslations = Object.freeze({
    // confirm: "Confirm",
    // cancel: "Cancel",
    confirmDelete: "Confirm delete",
    cancelDelete: "Cancel delete",
    confirmModify: "Confirm modification",
    cancelModify: "Cancel modification"
    // pin: "Pin",
    // unpin: "Unpin",
    // delete: "Delete",
    // modify: "Modify"
});
